import React, { ComponentPropsWithoutRef } from 'react';

import Currency from 'components/currency';
import { Typography } from 'components/ui/typography';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';

import { Total, TotalLabel, TotalsRow } from './styled';

type TextProps = ComponentPropsWithoutRef<typeof Typography>;

export const TaxesRow: React.FC<React.PropsWithChildren<{
  taxCents: number;
  isLoading?: boolean;
  textProps?: TextProps;
}>> = ({ taxCents, isLoading, textProps }) => {
  const { formatCurrencyForLocale } = useUIContext();

  return (
    <TotalsRow
      accessible={!isLoading}
      focusable={!isLoading}
      accessibilityLabel={
        !isLoading ? `${t('tax')}: ${formatCurrencyForLocale(taxCents)}` : undefined
      }
    >
      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <>
          <TotalLabel focusable={false} {...(textProps && { fontSize: 'md' })}>
            {t('tax')}
          </TotalLabel>
          <Total focusable={false}>
            <Currency focusable={false} textProps={textProps} amount={taxCents} testID="totalTax" />
          </Total>
        </>
      )}
    </TotalsRow>
  );
};
